import React from 'react'
import ReactDOM from 'react-dom'
import classes from './Settings.module.css'


const Backdrop = props => {
    return (
        <div className={classes.backdrop} onClick={props.onClose}></div>
    )
}

const PopUpWindow = props => {
    return (
        <div className={classes.popup}>
            <h3 className={classes.settingsheader}>SETTINGS</h3>
            <div className={classes.soundcheck}>
                <h1>Sound</h1>
                <label className={classes.switch}>
                    <input type="checkbox" checked={props.sound ? true : false} onChange={props.soundOnOff}/>
                    <span className={classes.slider}></span>
                </label>
            </div>
            <h3 className={classes.closebutton} onClick={props.onClose}>CLOSE</h3>
        </div>
    )
}



const popupPortal = document.getElementById('settings')

const Settings = props => {
    return (
        <>
            {ReactDOM.createPortal(<Backdrop onClose={props.onClose} />, popupPortal)}
            {ReactDOM.createPortal(<PopUpWindow onClose={props.onClose} sound={props.sound} soundOnOff={props.soundOnOff}/>, popupPortal)}
        </>
    )
}

export default Settings